/* global moment*/
angular
  .module('statVehicleCount')
  .component('statVehicleCount', {
    template: require('./stat-vehicle-count.template.html'),
    controller: ['$rootScope', '$scope', '$resource', '$route', '$location', '$window', '$translate', 'AuthService', 'envService',
      function StatVehicleCountController($rootScope, $scope, $resource, $route, $location, $window, $translate, AuthService, envService) {
        $scope.showEmployeeView = $rootScope.gShowEmployeeView;
        $scope.showUserView = $rootScope.gShowUserView;
        $scope.doLogout = $rootScope.gLogout;
        $rootScope.mainmenu = 'stat';
        $rootScope.menu = 'vehicleCount';
        this.targetBrand = '-1';
        this.targetType = '-1';
        const APIURL = envService.read('apiUrl');
        if (!AuthService.isAuthenticated()) {
          $location.path('/login');
          return;
        }

        const promiseVehicleMakeCount = page => $resource(`${APIURL}/admin/stat/vehicle/counts`).get({ page, itemcd: this.targetType, makercd: this.targetBrand }).$promise.then((data) => {
          this.count = data.count;
          this.cars = data.cars;
          console.log(data);
        });

        this.reload = (page) => {
          const promises = [promiseVehicleMakeCount(page - 1)];
          Promise.all(promises).then(() => {});
        };

        this.reload(1);


        $resource(`${APIURL}/admin/cars/brands`).get({}, (data) => {
          this.brands = data.brands;
        }, (err) => {
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
        $resource(`${APIURL}/admin/cars/types`).get({}, (data) => {
          this.types = data.types;
        }, (err) => {
          if (err.data && err.data.msg) {
            alert(err.data.msg);
          } else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
      },
    ],
  });



// WEBPACK FOOTER //
// ./src/app/stat-vehicle-count/stat-vehicle-count.component.js